﻿import { StatusBarWidget } from "./StatusBar";
import { DocumentsWidget } from "./addDoc";
import { ListWidget } from "./list";
import { ArchiveWidget } from "./archive";
import { SignatureWidget } from "./signature";
import { NoLoginSignWidget } from "./noLoginSign";
import { TemplatesWidget } from "./templates";
import { TermsAndConditionsWidget } from "./termsAndConditions";
import { JobWidget } from "./job";
import { NoLoginDenyWidget } from "./noLoginDeny";  

let statusBarWidget;
$(function () {
    console.log("ordo.js");
    //set navbar toggles
    let lgScreen = localStorage.getItem("LargeScreenLoading");
    if (lgScreen == "1") {
        $(".settings #CheckLargeScreen").prop("checked", true);
    }
    let smScreen = localStorage.getItem("MobileScreenLoading");
    if (smScreen == "1") {
        $(".settings #CheckMobileScreen").prop("checked", true);
    }
    $(".settings #CheckLargeScreen").on("change", function () {
        localStorage.setItem("LargeScreenLoading", $(this).prop("checked") ? "1" : "0");
        window.location.reload();
    })
    $(".settings #CheckMobileScreen").on("change", function () {
        localStorage.setItem("MobileScreenLoading", $(this).prop("checked") ? "1" : "0");
        window.location.reload();
    })

    $("#status-bar-widget").each(function () {
        statusBarWidget = new StatusBarWidget(this);
    })
    $(".documents-widget").each(function () {
        new DocumentsWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".templates-widget").each(function () {
        new TemplatesWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".list-widget").each(function () {
        new ListWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".archive-widget").each(function () {
        new ArchiveWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".signature-welcome-widget").each(function () {
        new NoLoginSignWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".terms-and-conditions-widget").each(function () {
        new TermsAndConditionsWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".job-widget").each(function () {
        new JobWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });
    $(".deny-welcome-widget").each(function () {
        new NoLoginDenyWidget(this, statusBarWidget);
        globalThis.Widget = 1;
    });

    //check login cookie
    //function checkLoginStatus() {
    //    $.ajax({
    //        url: '/status',
    //        type: 'GET',               
    //        success: function (response) {
    //            if (response === 'expired') {
    //                // Reload the page
    //                location.reload();
    //            }
    //        }
    //    }).catch(function (response) {
    //        if (response.statusText === 'error') {
    //            // Reload the page
    //            location.reload();
    //        }
    //    });
    //}

    //setInterval(checkLoginStatus, 60000); 

    
    
/*Header prijavljeni*/
    function flexTable() {
        if ($(window).width() < 768) {
            $(".custom-table").each(function (i) {
                $(this).find('.head').hide();
            });
        } else {
            $(".custom-table").each(function (i) {
                $(this).find('.head').show();
            });
        }
    }

    flexTable();

    window.onresize = function (event) {
        flexTable();
    };


    if ($(this).scrollTop() > $(".navbar-top").height()) {
        $(".navbar-sticky").addClass("stickTop");
    }
    //if ($(this).scrollTop() > 10) {
    //    $(".nav-mobile").css("background-color", "#fff");

    //}
    $(".nav-mobile").removeClass("hideup");
    $(".nav-mobile-burger").on("click", function (ev: Event) {
        ev.preventDefault();
        $(".mobile-nav-menu").toggleClass("show");
        $(this).toggleClass("opened");
    })
    $(".dropdown-toggle").dropdown();

    $("[data-onclick=openSettingsBtn]").on("click", function (ev: Event) {
        ev.preventDefault();
        $(".settings-menu").toggleClass("show");            
    })
    $(".settings-wrap, [data-onclick=closeSettingsBtn]").on("click", function (ev: Event) {
        ev.preventDefault();
        $(".settings-menu").toggleClass("show");
    })

    //settings

    var div = document.body;
    var mouse = {
        isDown: false,
        inLeft: false,
        inRight: false,
        downTimestamp: null
    };
    var width, thresholdStart, thresholdEnd, thresholdMilliseconds;

    function resize() {
        width = window.innerWidth;
        thresholdStart = 0.1 * width;//within 10% of screen width
        thresholdEnd = 0.13 * width;//beyond 13% of screen width
        thresholdMilliseconds = 500;//must be done in 500 milliseconds
    }
    document.addEventListener("resize", resize, false);
    resize();//initialize

    div.addEventListener('touchstart', function (e) {
        var x = e.touches[0].pageX;
        mouse.isDown = true;
        mouse.downTimestamp = performance.now();

        if (x < thresholdStart) {
            mouse.inLeft = true;
        } else if (x > width - thresholdStart) {
            mouse.inRight = true;
        }
    });
    div.addEventListener('touchmove', function (e) {

        var x = e.touches[0].pageX;
        if (mouse.inLeft && x > thresholdEnd) {
            mouse.inLeft = false;
            if (performance.now() - mouse.downTimestamp < thresholdMilliseconds) {
                swipeEdgeFromLeft();
            }
        } else if (mouse.inRight && x < width - thresholdEnd) {
            mouse.inRight = false;
            if (performance.now() - mouse.downTimestamp < thresholdMilliseconds) {
                swipeEdgeFromRight();
            }
        }
    });
    div.addEventListener('touchend', function (e) {
        var x = e.changedTouches[0].pageX;
        mouse.isDown = false;
        mouse.inLeft = false;
        mouse.inRight = false;
        mouse.downTimestamp = null;
    });
    function swipeEdgeFromLeft() {
        console.log("edge swipe from left");
        if (!$(".nav-mobile-burger").hasClass("opened")) {
            $(".mobile-nav-menu").toggleClass("show");
            $(".nav-mobile-burger").toggleClass("opened");
        }  
    }
    function swipeEdgeFromRight() {
        console.log("edge swipe from left");
        if ($(".nav-mobile-burger").hasClass("opened")) {
            $(".mobile-nav-menu").toggleClass("show");
            $(".nav-mobile-burger").toggleClass("opened");
        }          
    }
    //end settings

    var lastSt = 0;
    $(window).on("scroll", function () {
        var st = $(this).scrollTop();

        var navHeight = $(".navbar-top").height() + 1;
        if (st > 0 && st < navHeight - 1) {
            $(".navbar-sticky").css("top", navHeight - st);
        }
        else if (st == 0) {
            $(".navbar-sticky").css("top", navHeight);
        }
        if (st >= navHeight) {
            $(".navbar-sticky").addClass("stickTop");
        } else {
            $(".navbar-sticky").removeClass("stickTop");
        }
        if (lastSt < st) {
            $(".nav-mobile").addClass("hideup");
        }
        else {
            $(".nav-mobile").removeClass("hideup");
        }
        //if (st > 10) {
        //    $(".nav-mobile").css("background-color", "#fff");
        //}
        //else {
        //    $(".nav-mobile").css("background-color", "transparent");
        //}

        lastSt = st;
    });
});